import { styled, Box, TextField, Select, InputLabel } from "@mui/material";

export const ContactFormRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: "3rem",
  boxSizing: "border-box",
  backdropFilter: "blur(0.5rem)",
  width: "95%",
  height: "fit-content",
  position: "absolute",
  gap: 10,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  margin: "auto",
  maxHeight: "90vh",
  background: `rgba(${theme?.palette?.companyColors?.neutralRGB}, 0.9)`,
  borderRadius: theme?.borderRadius?.small,
  boxShadow: "none",
  overflowX: "hidden",
  overflowY: "auto",
  [theme.breakpoints.up("md")]: {
    width: "70%",
    borderRadius: theme?.borderRadius?.big,
  },
  [theme.breakpoints.up("xl")]: {
    padding: "5rem",
    width: "60%",
    gap: 20,
  },
}));

export const TextFieldContactForm = styled(TextField)(({ theme }) => ({
  label: {
    fontSize: "1.75rem",
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.35rem",
    },
  },
  input: {
    fontSize: "1.75rem",
    backgroundColor: theme?.palette?.companyColors?.neutral,
    borderRadius: theme?.borderRadius?.small,
    overflow: "hidden",
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.35rem",
    },
  },
  fieldset: {
    fontSize: "1.75rem",
    border: "none",
    borderBottom: `1px solid ${theme?.palette?.companyColors?.greyLight1}`,
    borderRadius: theme?.borderRadius?.small,
    [theme.breakpoints.up("lg")]: {
      fontSize: "1.35rem",
    },
  },
}));

export const SelectContactForm = styled(Select)(({ theme }) => ({
  backgroundColor: theme?.palette?.companyColors?.neutral,
  borderRadius: theme?.borderRadius?.small,
  fontSize: "1.75rem",
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.35rem",
  },
  fieldset: {
    border: "none",
    borderBottom: `1px solid ${theme?.palette?.companyColors?.greyLight1}`,
  },
}));

export const InputLabelContactForm = styled(InputLabel)(({ theme }) => ({
  fontSize: "1.75rem",
  [theme.breakpoints.up("lg")]: {
    fontSize: "1.5rem",
  },
}));
